<template>
    <div>
        <b-modal @show="getParams(); getAcquisitionBatches()" :id="typeof book_id === 'undefined' ? 'new-book' : 'edit-book-' + book_id" :title="typeof book_id === 'undefined' ? 'Додати примірник' : 'Редагувати примірник'" hide-footer>
            <div v-if="params != null">
                <div class="modal-body">
                    <div class="form-group" v-if="!book_id">
                        <label for="count_book">Кількість примірників</label>
                        <input type="number" v-model="book.count_book" id="count_book" class="form-control" min="1" max="10" value="1">
                    </div>
<!--                    <div class="form-group">-->
<!--                        <label for="library_id">Бібліотека</label>-->
<!--                        <select required v-model="book.library_id" id="library_id" class="form-control">-->
<!--                            <option :value="params.library.id">{{ params.library.title }}</option>-->
<!--                            <option v-for="item in params.library.children" :value="item.id">{{ item.title }}</option>-->
<!--                        </select>-->
<!--                    </div>-->
                    <div class="form-group">
                        <label for="price">Ціна</label>
                        <input id="price" type="text" class="form-control" name="price" @input="priceMask" v-model.lazy="book.price" ref="price" />
                    </div>
                    <div class="form-group">
                        <label for="example_id">Тип екземпляру</label>
                        <select @change="changeExample(book.example_id)" required v-model="book.example_id" id="example_id" class="form-control" ref="example_id">
                            <option v-for="item in params.examples" :value="item.id">{{ item.title }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="expired">Кількість діб:</label>
                        <input type="number" v-model="book.expired" id="expired" ref="expired" class="form-control">
                    </div>
                    <div class="form-group">
                        <label for="invent_number">Інвентарний номер</label>
                        <input type="text" v-model="book.invent_number" id="invent_number" class="form-control" required>
                    </div>
                    <div class="form-group">
                        <label for="source">Джерело надходження</label>
                        <input type="text" v-model="acquisitionBatch.source" id="source" class="form-control" disabled>
                    </div>
                    <div class="form-group">
                        <label for="generarType">Загальний тип</label>
                        <input type="text" v-model="acquisitionBatch.general_type" id="generarType" class="form-control" disabled>
                    </div>
                  <div class="form-group">
                    <label for="acquisition-batch-id">Номер партії комплектування</label>
                    <input v-if="acquisitionBatch.status === 'завершений'" type="text" :value="acquisitionBatch.doc_number + ' від ' + acquisitionBatch.doc_date" id="acquisition-batch-id" class="form-control" disabled>
                    <select v-else v-model="book.acquisition_batch_id" id="acquisition-batch-id" class="form-control" :disabled="!library.complect">
                      <option v-for="item in acquisitionBatches" :value="item.id">{{ item.doc_number + ' від ' + item.doc_date }}</option>
                    </select>
                  </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="closeModal">Відмінити</button>
                    <button type="submit" class="btn btn-primary" @click="saveBook">Зберегти книгу</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "CreateEditBook",
        props:['description_id','book_id'],
        data(){
          return {
              book:{
                  count_book:1,
                  example_id:null,
                  price:null,
                  expired:null,
                  invent_number:null,
                  description_id:this.description_id,
                  library_id:this.$root.$data.libraryId,
                  acquisition_batch_id:null
              },
              acquisitionBatch: {
                id:null,
                doc_number:null,
                doc_date:null,
                source:null,
                general_type:null,
                status:null,
              },
              params:null,
              acquisitionBatches:{},
              library:{},
          }
        },
      mounted() {
          this.getLibrary();
      },
        methods:{
            changeExample(val){
                switch(val){
                    case 1:
                        this.book.expired = this.params.examples[0].pivot ? this.params.examples[0].pivot.value : 1;
                        break;
                    case 2:
                        this.book.expired = this.params.examples[1].pivot ? this.params.examples[1].pivot.value : 20;
                        break;
                    default:
                        this.book.expired = null;
                        break;
                }
            },
            getBook(){
                axios.get('/library/book/' + this.book_id).then(response => {
                    this.book = response.data.book;
                    this.acquisitionBatch = response.data.acquisitionBatch ? response.data.acquisitionBatch : {};
                    this.book.description_id = this.description_id;
                });
            },
            closeModal(){
                this.book = {
                    count_book:1,
                    library_id:null,
                    example_id:null,
                    price:null,
                    expired:null,
                    invent_number:null,
                };
                this.$bvModal.hide(typeof this.book_id === 'undefined' ? 'new-book' : 'edit-book-' + this.book_id);
            },
            saveBook(){
                let url = '/library/newbook';
                let method = 'post'
                if(this.book.hasOwnProperty('id')){
                    url = '/library/book/' + this.book.id;
                    method = 'put';
                }
                axios({
                    method: method,
                    url: url,
                    data:this.book
                }).then(response => {
                    if(response.data.status === 'success'){
                        this.$bvModal.hide(typeof this.book_id === 'undefined' ? 'new-book' : 'edit-book-' + this.book_id);
                        this.book = {
                            count_book:1,
                            library_id:null,
                            example_id:null,
                            price:null,
                            expired:null,
                            invent_number:null,
                            params:null,
                        };
                        Swal(
                            'Збережено!',
                        ).then(() => {
                            window.location.reload();
                        });
                    }
                }).catch(res=>{
                  console.log(res.response.data.errors);

                  Object.keys(res.response.data.errors).forEach((el) => {
                      this.$refs[el].focus();
                  });
                });
            },
            getParams(){
                axios.get('/library/description/' + this.description_id).then(response => {
                    this.params = response.data;
                });
                if(this.book_id){
                    this.getBook();
                }
            },
            priceMask(){
                $('[name=price]').mask('000 000 000 000 000 грн. 00 коп.', {reverse: true});
            },
            getAcquisitionBatches(){
              if (this.acquisitionBatches.length || !this.library.complect) {
                return;
              }
              axios.get('/library/acquisition-batches?forBook=1').then(response => {
                if (response.data) {
                  this.acquisitionBatches = response.data;
                }
              });
            },
          getLibrary(){
            axios.get('/library').then(res => {
              this.library = res.data;
            })
          },
        },
    }
</script>

<style scoped>
    .modal-body{
      padding: unset;
    }
    [type=checkbox]:checked + label:before{
        width: unset;
        height: unset;
    }
</style>